@for (row of rows; track $index) {
<div class="row gap">
  <div class="label">{{ row.label }} <span>:</span></div>
  <div class="content">
    @if (customContent && customContent[row.key]) {
    <ng-container *ngTemplateOutlet="customContent[row.key]; context: { $implicit: reportSummary }"> </ng-container>
    } @else {
    {{ row.accessor(reportSummary) }}
    }
  </div>
</div>
} @if (customRowTpl) { @for (key of templateKeys(); track $index) {
<ng-container *ngTemplateOutlet="templates[key]; context: { $implicit: reportSummary }"> </ng-container>
} }
